/****************************************** VIEW ALL BUTTON CLICK JS START *************************************/
let bundleVariantData = [];

document.addEventListener('DOMContentLoaded', () => {
  // View All Button Click
  document.querySelectorAll('.view-all-button').forEach((btn) => {
    btn.addEventListener('click', () => {
      var collectionWrapper = btn.closest('.collection-wrapper');
      collectionWrapper.querySelectorAll('.collection-item.hide-product').forEach((item) => {
        item.classList.remove('hide-product');
      });
      btn.style.display = 'none';
    });
  });

  // Collection Tab Click
  document.querySelectorAll('.collection-tabing-wrapper a').forEach((link) => {
    link.addEventListener('click', () => {
      document.querySelectorAll('.collection-tabing-wrapper a').forEach((a) => {
        a.classList.remove('active');
      });
      link.classList.add('active');
    });
  });

  sameBoxCard();

  // Version Two section check interval (replaces slick refresh)
  var v1InterId = setInterval(() => {
    var v2Section = document.querySelector('.page-container .bundle-builder-section.version-two');
    if (v2Section) {
      sameBoxCard();
      clearInterval(v1InterId);
    }
  }, 1000);
});
/****************************************** VIEW ALL BUTTON CLICK JS END ***************************************/

/************************************ PRODUCT COLOR VARIANT ACTIVE CLICK JS START ********************************/

document.addEventListener('click', (e) => {
  var swatch = e.target.closest('.grid-product__colors .color-swatch--with-image');
  if (!swatch) return;

  var parent = swatch.parentElement;
  if (parent.querySelectorAll('.color-swatch--with-image').length > 0) {
    parent.querySelectorAll('.color-swatch--with-image').forEach((s) => {
      s.classList.remove('active');
    });
    swatch.classList.add('active');
  }

  var productInfo = swatch.closest('.product-info');
  var selectedVariantId = getVariantId(productInfo);
  var quantitySelector = productInfo.querySelector('.quantity-selector');
  var addButton = productInfo.querySelector('.product-btn');

  var variantData = false;
  if (selectedVariantId != '' && selectedVariantId != undefined) {
    variantData = bundleVariantData.find((item) => item.variant_id == selectedVariantId);
  }

  if (document.querySelector('.bundle-builder-section.version-one')) {
    if (variantData) {
      quantitySelector.style.display = 'flex';
      addButton.style.display = 'none';
      quantitySelector.querySelector('.quantity-value').value = variantData.variant_quantity;
      quantitySelector.querySelector('.quantity-value').setAttribute('data-variant-id', selectedVariantId);
    } else {
      quantitySelector.style.display = 'none';
      addButton.style.display = '';
      var min = parseInt(quantitySelector.querySelector('.quantity-value').getAttribute('min')) || 1;
      quantitySelector.querySelector('.quantity-value').value = min;
    }
  } else if (document.querySelector('.bundle-builder-section.version-two')) {
    if (variantData) {
      quantitySelector.style.display = 'flex';
      quantitySelector.querySelector('.quantity-value').value = variantData.variant_quantity;
    } else {
      quantitySelector.style.display = 'none';
      var min = parseInt(quantitySelector.querySelector('.quantity-value').getAttribute('min')) || 1;
      quantitySelector.querySelector('.quantity-value').value = min;
    }
  }
});

/************************************* PRODUCT COLOR VARIANT ACTIVE CLICK JS END *********************************/

/************************************ PRODUCT ADD TO BUNDLE AND BUTTON CLICK JS START **********************************/

document.addEventListener('click', (e) => {
  var btn = e.target.closest('.bundle-builder-section .product-btn');
  if (!btn) return;

  if (!btn.closest('.bundle-builder-section').classList.contains('version-one')) {
    var variantSelect = btn.parentElement.querySelector('.product-variant-select');
    if (variantSelect) {
      variantSelect.style.display = '';
      btn.style.display = 'none';
    }
  } else {
    var quantitySelector = btn.parentElement.parentElement.querySelector('.quantity-selector');
    if (quantitySelector) quantitySelector.style.cssText = 'display:flex';
    btn.style.display = 'none';
    var obj = btn.closest('.product-info');
    var handleVariant = selectVariantGet(obj);
    if (handleVariant != undefined && handleVariant != '') {
      bundlePackHtml();
    }
  }
});

// Option Change Variant JS
document.addEventListener('change', (e) => {
  var select = e.target.closest('.bundle-builder-section.version-one .product-variant-select.dynamic-option');
  if (!select) return;

  var productInfo = select.closest('.product-info');
  var selectedVariantId = getVariantId(productInfo);
  var quantitySelector = productInfo.querySelector('.quantity-selector');
  var addButton = productInfo.querySelector('.product-btn');

  var variantData = false;
  if (selectedVariantId != '' && selectedVariantId != undefined) {
    variantData = bundleVariantData.find((item) => item.variant_id == selectedVariantId);
  }

  if (variantData) {
    quantitySelector.style.display = 'flex';
    addButton.style.display = 'none';
    quantitySelector.querySelector('.quantity-value').value = variantData.variant_quantity;
  } else {
    quantitySelector.style.display = 'none';
    addButton.style.display = '';
    var min = parseInt(quantitySelector.querySelector('.quantity-value').getAttribute('min')) || 1;
    quantitySelector.querySelector('.quantity-value').value = min;
  }
});

function getVariantId(buttonObj) {
  if (buttonObj == undefined) return;
  var variantArray = [];

  buttonObj.querySelectorAll('.product-variant-select.dynamic-option').forEach((sel) => {
    if (sel.classList.contains('version-variant')) {
      var selectedOpt = sel.options[sel.selectedIndex];
      var variant_option_val = selectedOpt ? selectedOpt.getAttribute('data-option') : '';
      var option_value = selectedOpt ? selectedOpt.getAttribute('data-value') : '';
      var variantKey = sel.getAttribute('data-option-name');
      variantArray.push({ key: variantKey, value: variant_option_val, main_value: option_value });
    }
  });

  var colorSwatch = buttonObj.querySelector('.grid-product__colors .color-swatch-ci.active');
  if (colorSwatch) {
    variantArray.push({
      key: 'Color',
      value: colorSwatch.getAttribute('data-option'),
      main_value: colorSwatch.getAttribute('data-value'),
      color_image: colorSwatch.getAttribute('data-color-img')
    });
  }

  buttonObj.querySelectorAll('.product-variant-select.dynamic-option').forEach((sel) => {
    if (!sel.classList.contains('version-variant')) {
      var selectedOpt = sel.options[sel.selectedIndex];
      var variant_option_val = selectedOpt ? selectedOpt.getAttribute('data-option') : '';
      var option_value = selectedOpt ? selectedOpt.getAttribute('data-value') : '';
      var variantKey = sel.getAttribute('data-option-name');
      variantArray.push({ key: variantKey, value: variant_option_val, main_value: option_value });
    }
  });

  var variant_handle = variantArray.map((opt) => opt.value).join('-');
  var variantId = '';
  if (variant_handle) {
    var opt = buttonObj.querySelector('.hidden-variant-select option[data-vhandle="' + variant_handle + '"]');
    if (opt) variantId = opt.value;
  }
  return variantId;
}

function calculateStrapTotals(bundleData) {
  let strapCount = 0;
  let totalPrice = 0;
  let totalComparePrice = 0;
  let strapCheck = 0;

  for (const item of bundleData) {
    if (item) {
      const productTitle = item.product_title?.toLowerCase() || '';
      if (productTitle.includes('strap') && !productTitle.includes('strap bag')) {
        strapCheck = 1;
        strapCount += parseInt(item.variant_quantity) || 0;
      }
    }
  }

  let paidStraps = 0;
  let freeStraps = 0;
  let strapBoxFree = 0;

  if (strapCount <= 1) {
    paidStraps = strapCount; freeStraps = 0; strapBoxFree = 1;
  } else if (strapCount === 2) {
    paidStraps = 1; freeStraps = 1;
  } else if (strapCount === 3 || strapCount === 4) {
    paidStraps = 2; freeStraps = strapCount - 2;
  } else if (strapCount === 5) {
    paidStraps = 2; freeStraps = 3;
  } else if (strapCount === 6) {
    paidStraps = 3; freeStraps = 3; strapBoxFree = 6;
  } else if (strapCount === 7) {
    paidStraps = 3; freeStraps = 4;
  } else if (strapCount >= 8) {
    paidStraps = strapCount - 4; freeStraps = 4;
  }
  if (strapCount == 3) strapBoxFree = 3;

  console.log("freeStraps", freeStraps, strapCount);

  var bundleCart = document.querySelector('.right-product-details-side.bundle-cart');
  if (bundleCart) {
    var addProductCards = bundleCart.querySelectorAll('.product-card.add-product-card');
    addProductCards.forEach((card) => {
      if ((strapBoxFree == 1 || strapBoxFree == 3 || strapBoxFree == 6) && strapCount > 0) {
        card.style.display = '';
      } else {
        card.style.display = 'none';
      }
    });
  }

  var v2Section = document.querySelector('.bundle-builder-section.version-two');
  if (v2Section) {
    var stickyBoxes = v2Section.querySelectorAll('.sticky-bundle-builder .image-box.blank-card');
    stickyBoxes.forEach((box) => {
      if ((strapBoxFree == 1 || strapBoxFree == 3 || strapBoxFree == 6) && strapCount > 0) {
        box.style.display = '';
      } else {
        box.style.display = 'none';
      }
    });
  }

  let processedCount = 0;
  for (const item of bundleData) {
    if (item) {
      const productTitle = item.product_title?.toLowerCase() || '';
      if (productTitle.includes('strap') && !productTitle.includes('strap bag')) {
        const quantity = parseInt(item.variant_quantity) || 0;
        const price = parseFloat(item.variant_original_price || 0);
        const comparePrice = parseFloat(item.variant_original_cprice || 0);
        for (let q = 0; q < quantity; q++) {
          processedCount++;
          if (processedCount <= paidStraps) {
            totalPrice += price;
            totalComparePrice += comparePrice;
          }
        }
      }
    }
  }

  return { strapCount, paidStraps, freeStraps, totalPrice, totalComparePrice, strapCheck };
}

function selectVariantGet(buttonObj) {
  if (buttonObj == undefined) return;
  var variantArray = [];
  var colorSwatch;

  if (document.querySelector('.bundle-builder-section.version-two')) {
    buttonObj = buttonObj.nextElementSibling; // .product-info
    colorSwatch = buttonObj ? buttonObj.querySelector('.grid-product__colors .color-swatch-ci.active') : null;
  } else {
    colorSwatch = buttonObj.querySelector('.grid-product__colors .color-swatch-ci.active');
  }

  if (!buttonObj) return;

  buttonObj.querySelectorAll('.product-variant-select.dynamic-option').forEach((sel) => {
    if (sel.classList.contains('version-variant')) {
      var selectedOpt = sel.options[sel.selectedIndex];
      variantArray.push({
        key: sel.getAttribute('data-option-name'),
        value: selectedOpt ? selectedOpt.getAttribute('data-option') : '',
        main_value: selectedOpt ? selectedOpt.getAttribute('data-value') : ''
      });
    }
  });

  if (colorSwatch) {
    variantArray.push({
      key: 'Color',
      value: colorSwatch.getAttribute('data-option'),
      main_value: colorSwatch.getAttribute('data-value'),
      color_image: colorSwatch.getAttribute('data-color-img')
    });
  }

  buttonObj.querySelectorAll('.product-variant-select.dynamic-option').forEach((sel) => {
    if (!sel.classList.contains('version-variant')) {
      var selectedOpt = sel.options[sel.selectedIndex];
      variantArray.push({
        key: sel.getAttribute('data-option-name'),
        value: selectedOpt ? selectedOpt.getAttribute('data-option') : '',
        main_value: selectedOpt ? selectedOpt.getAttribute('data-value') : ''
      });
    }
  });

  var variant_handle = variantArray.map((opt) => {
    if (opt.value != '' && opt.value != undefined) return opt.value;
  }).join('-');

  if (variant_handle) {
    var quantityGet = 1;
    var selectedVariant;

    if (document.querySelector('.bundle-builder-section.version-two')) {
      console.log("buttonObj", buttonObj);
      selectedVariant = buttonObj.parentElement.querySelector('.hidden-variant-select option[data-vhandle="' + variant_handle + '"]');
      quantityGet = 1;
    } else if (document.querySelector('.bundle-builder-section.version-one')) {
      selectedVariant = buttonObj.querySelector('.hidden-variant-select option[data-vhandle="' + variant_handle + '"]');
      var qv = buttonObj.querySelector('.quantity-value');
      quantityGet = qv ? qv.value : 1;
    }

    if (selectedVariant) {
      const variantId = selectedVariant.value;
      console.log("variantId", variantId);
      let index = findVariantIndex(bundleVariantData, variantId);
      console.log("index", index);

      if (document.querySelector('.bundle-builder-section.version-one')) {
        var qvInput = buttonObj.querySelector('.quantity-selector .quantity-value');
        if (qvInput) qvInput.setAttribute('data-variant-id', variantId);
      } else if (document.querySelector('.bundle-builder-section.version-two')) {
        index = -1;
      }

      if (index !== -1) {
        bundleVariantData[index].variant_quantity = quantityGet;
      } else {
        bundleVariantData.push({
          variant_price: selectedVariant.getAttribute('data-vprice'),
          variant_c_price: selectedVariant.getAttribute('data-compare-vprice'),
          variant_original_price: selectedVariant.getAttribute('data-original-vprice'),
          variant_original_cprice: selectedVariant.getAttribute('data-original-compare-vprice'),
          variant_image: selectedVariant.getAttribute('data-vimage'),
          variant_id: variantId,
          product_title: selectedVariant.getAttribute('data-ptitle'),
          variant_handle: selectedVariant.getAttribute('data-vhandle'),
          variant_option: variantArray,
          variant_quantity: quantityGet
        });
      }
    }
  }
  return variant_handle;
}

function findVariantIndex(array, variantId) {
  for (let i = 0; i < array.length; i++) {
    if (array[i].variant_id === variantId) return i;
  }
  return -1;
}

function bundlePackHtml() {
  var totalQuantity = 0;
  var totalComparePrice = 0;
  var totalPrice = 0;

  if (bundleVariantData.length > 0) {
    var bundleCart = document.querySelector('.right-product-details-side.bundle-cart');
    var v2Section = document.querySelector('.bundle-builder-section.version-two');
    var v1Section = document.querySelector('.bundle-builder-section.version-one');

    if (bundleCart && bundleCart.querySelector('.cart-product-item-wrapper')) {
      var compareSubTotal = bundleCart.querySelector('.bundle-cart-footer .original-price.compare-sub-total');
      if (compareSubTotal) compareSubTotal.style.display = '';

      var $wrapper = bundleCart.querySelector('.cart-product-item-wrapper');
      var variantHtmlBundle = '';

      if (v2Section) {
        $wrapper = v2Section;
      } else if (v1Section) {
        $wrapper.querySelectorAll('.product-card.blank-card').forEach((c) => { c.style.display = 'none'; });
      }

      for (var j = 0; j < bundleVariantData.length; j++) {
        var variantId = bundleVariantData[j].variant_id;
        var variantQuantity = bundleVariantData[j].variant_quantity;
        var variantOriginlPrice = bundleVariantData[j].variant_original_price;
        var variantOriginlCPrice = bundleVariantData[j].variant_original_cprice;
        var variantImage = bundleVariantData[j].variant_image;
        var productTitle = bundleVariantData[j].product_title;
        var optionVariant = bundleVariantData[j].variant_option;
        var varaintPrice = bundleVariantData[j].variant_price;
        var varaintCPrice = bundleVariantData[j].variant_c_price;

        if (v1Section) {
          var existingProduct = null;
          $wrapper.querySelectorAll('.product-card:not(.add-product-card)').forEach((card) => {
            if (card.dataset.variantId == variantId) existingProduct = card;
          });

          var cartCard = bundleCart.querySelector('.product-card[data-variant-id="' + variantId + '"]');
          if (cartCard) {
            var minusIcon = cartCard.querySelector('.quantity-btn .minus-icon');
            var removeIcon = cartCard.querySelector('.quantity-btn .remove-icon');
            if (variantQuantity > 1) {
              if (minusIcon) minusIcon.style.display = '';
              if (removeIcon) removeIcon.style.display = 'none';
            } else {
              if (minusIcon) minusIcon.style.display = 'none';
              if (removeIcon) removeIcon.style.display = '';
            }
          }

          if (existingProduct) {
            var qInput = existingProduct.querySelector('.quantity-input');
            if (qInput) qInput.value = variantQuantity;
          } else {
            var optionsHtml = '';
            for (var g = 0; g < optionVariant.length; g++) {
              if (optionVariant[g].key != undefined) {
                var keyval = optionVariant[g].key.toLowerCase();
                if (keyval != 'version') {
                  var value_option = optionVariant[g].main_value;
                  if (keyval == 'color') {
                    var colorImg = optionVariant[g].color_image;
                    optionsHtml += '<div class="option-row"><span class="option-label ' + keyval + '">' + optionVariant[g].key + ':</span>';
                    optionsHtml += '<span class="color--swatch"><img src="' + colorImg + '"></span>';
                    optionsHtml += '<span class="option-value">' + value_option + '</span></div>';
                  } else {
                    optionsHtml += '<div class="option-row"><span class="option-label ' + keyval + '">' + optionVariant[g].key + ':</span>';
                    optionsHtml += '<span class="option-value">' + value_option + '</span></div>';
                  }
                }
              }
            }

            var newCard = document.createElement('div');
            newCard.className = 'product-card';
            newCard.setAttribute('data-variant-id', variantId);
            newCard.innerHTML =
              '<div class="product-image"><img src="' + variantImage + '"></div>' +
              '<div class="product-info"><h3 class="product-title">' + productTitle + '</h3>' +
              '<div class="product-options">' + optionsHtml + '</div>' +
              '<div class="product-pricing-quantity-wrapper"><div class="product-pricing">' +
              (varaintCPrice ? '<span class="price-original">' + varaintCPrice + '</span>' : '') +
              '<span class="price-sale">' + varaintPrice + '</span></div>' +
              '<div class="quantity-control">' +
              '<button class="quantity-btn minus bundle-picker">' +
              '<svg class="minus-icon" style="display:none;" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M0.555542 4.5H9.44421V5.5H0.555542V4.5Z" fill="black"/></svg>' +
              '<svg class="remove-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1.75 3.50002H12.25M11.0833 3.50002V11.6667C11.0833 12.2729 10.5228 12.8334 9.91667 12.8334H4.08333C3.77391 12.8334 3.47717 12.7104 3.25838 12.4916C3.03958 12.2729 2.91667 11.9761 2.91667 11.6667V3.50002M4.08333 3.50002L5.25 1.16669H8.75L9.91667 3.50002" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
              '</button>' +
              '<input type="number" class="quantity-input quantity-value" data-variant-id="' + variantId + '" value="' + variantQuantity + '" min="1" pattern="[0-9]*">' +
              '<button class="quantity-btn plus bundle-picker"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M5.49988 4.49988H9.44421V5.49988H5.49988V9.44421H4.49988V5.49988H0.555542V4.49988H4.49988V0.555542H5.49988V4.49988Z" fill="black"/></svg></button>' +
              '</div></div></div></div>';

            var firstAddCard = $wrapper.querySelector('.product-card.add-product-card');
            if (firstAddCard) {
              $wrapper.insertBefore(newCard, firstAddCard);
            } else {
              $wrapper.appendChild(newCard);
            }
          }
        } else if (v2Section) {
          variantHtmlBundle +=
            '<div class="image-box image-added" data-variant-id="' + variantId + '"><div class="close-icon">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="7" viewBox="0 0 8 7" fill="none"><path d="M4.8687 3.32087L7.26209 5.71427L6.39339 6.58296L4 4.18957L1.60592 6.58365L0.737231 5.71496L3.13131 3.32087L0.73654 0.926103L1.60523 0.0574113L4 2.45218L6.39409 0.0581018L7.26278 0.926794L4.8687 3.32087Z" fill="white"/>' +
            '</svg></div><img src="' + variantImage + '" alt="' + productTitle + '">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.75 7.25H16V8.75H8.75V16H7.25V8.75H0V7.25H7.25V0H8.75V7.25Z" fill="black"/></svg></div>';

          var stickyBuilder = $wrapper.querySelector('.sticky-bundle-builder');
          if (stickyBuilder) {
            stickyBuilder.querySelectorAll('.bundle-form .product-variant-select.dynamic-option').forEach((sel) => {
              sel.value = '';
              sel.style.display = 'none';
            });
            stickyBuilder.querySelectorAll('.bundle-form .product-btn').forEach((btn) => {
              btn.style.display = '';
            });
          }
        }

        totalQuantity += parseInt(variantQuantity);
        totalPrice += (parseInt(variantOriginlPrice) * variantQuantity);
        totalComparePrice += (parseInt(variantOriginlCPrice) * variantQuantity);
      }

      if (v2Section) {
        var stickyBuilder = v2Section.querySelector('.sticky-bundle-builder');
        if (stickyBuilder && variantHtmlBundle != '') {
          variantHtmlBundle += v2blankBoxHtml();
          var imageBoxes = stickyBuilder.querySelector('.image-boxes');
          if (imageBoxes) imageBoxes.innerHTML = variantHtmlBundle;
        }
      }
    }
  } else {
    var v1Section = document.querySelector('.bundle-builder-section.version-one');
    if (v1Section) {
      v1Section.querySelectorAll('.product-card.blank-card').forEach((c) => { c.style.display = ''; });
    }
  }

  const totals = calculateStrapTotals(bundleVariantData);
  totalPrice = totals.totalPrice;
  totalComparePrice = totals.totalComparePrice;

  var v1Section = document.querySelector('.bundle-builder-section.version-one');
  var v2Section = document.querySelector('.bundle-builder-section.version-two');
  var bundleCart = document.querySelector('.right-product-details-side.bundle-cart');

  if (v1Section) {
    var cartCount = bundleCart && bundleCart.querySelector('.cart-count');
    if (cartCount) cartCount.textContent = totalQuantity;

    var priceValueEl = bundleCart && bundleCart.querySelector('.bundle-cart-footer .price-value');
    if (priceValueEl) {
      var fmtCompare = Shopify.formatMoney(totalComparePrice);
      var fmtPrice = Shopify.formatMoney(totalPrice);
      var compareEl = bundleCart.querySelector('.bundle-cart-footer .original-price.compare-sub-total');
      var currentEl = bundleCart.querySelector('.bundle-cart-footer .current-price.sub-total');
      if (compareEl) compareEl.textContent = fmtCompare;
      if (currentEl) currentEl.textContent = fmtPrice;
    }
  } else if (v2Section) {
    var subTotalEl = v2Section.querySelector('.price-info .current-price.sub-total');
    if (subTotalEl) {
      var savingPrice = 0;
      if (totalComparePrice != 0 && parseInt(totalComparePrice) > parseInt(totalPrice)) {
        savingPrice = parseInt(totalComparePrice) - parseInt(totalPrice);
      }
      var compareSubTotalEl = v2Section.querySelector('.price-column .original-price.compare-sub-total');
      var savingsEl = v2Section.querySelector('.price-column .savings');
      if (savingPrice > 0) {
        if (compareSubTotalEl) compareSubTotalEl.style.display = '';
        if (savingsEl) savingsEl.style.display = '';
        var fmtSaving = Shopify.formatMoney(savingPrice);
        var savingsSpan = v2Section.querySelector('.price-column .savings span');
        if (savingsSpan) savingsSpan.textContent = fmtSaving;
      } else {
        if (compareSubTotalEl) compareSubTotalEl.style.display = 'none';
        if (savingsEl) savingsEl.style.display = 'none';
      }
      var fmtCompare = Shopify.formatMoney(totalComparePrice);
      var fmtPrice = Shopify.formatMoney(totalPrice);
      var v2CompareEl = v2Section.querySelector('.price-info .original-price.compare-sub-total');
      var v2CurrentEl = v2Section.querySelector('.price-info .current-price.sub-total');
      if (v2CompareEl) v2CompareEl.textContent = fmtCompare;
      if (v2CurrentEl) v2CurrentEl.textContent = fmtPrice;
    }
  }

  bundleBuilderProgress();
}

//PRODUCT COLLECTION QUANTITY PICKER JS START
function setValue(newVal, input) {
  var min = parseInt(input.getAttribute('min')) || 1;
  var max = parseInt(input.getAttribute('max')) || null;
  if (newVal < min) newVal = min;
  if (max && newVal > max) newVal = max;
  input.value = newVal;
  input.dispatchEvent(new Event('change'));
}

document.addEventListener('click', (e) => {
  // PLUS button - version one
  var plusBtn = e.target.closest('.bundle-builder-section.version-one .quantity-btn.plus');
  if (plusBtn) {
    var selector = plusBtn.parentElement;
    var input = selector.querySelector('.quantity-value');
    var current = parseInt(input.value) || 0;
    var variantId = parseInt(input.getAttribute('data-variant-id'));

    if (!variantId) return;

    var newVal = current + 1;
    input.value = newVal;
    input.dispatchEvent(new Event('change'));

    if (plusBtn.classList.contains('bundle-picker')) {
      document.querySelectorAll('.bundle-builder-section .quantity-selector .quantity-value[data-variant-id="' + variantId + '"]').forEach((inp) => {
        inp.value = newVal;
        inp.dispatchEvent(new Event('change'));
        inp.parentElement.style.display = '';
        var productBtn = inp.parentElement.parentElement.querySelector('.product-btn');
        if (productBtn) productBtn.style.display = 'none';
      });
    }

    var variantIndex = bundleVariantData.findIndex((item) => item.variant_id == variantId);
    if (variantIndex > -1) {
      bundleVariantData[variantIndex].variant_quantity = newVal;
    } else {
      bundleVariantData.push({ variant_id: variantId, variant_quantity: newVal });
    }

    var obj = plusBtn.closest('.product-info');
    if (obj) {
      selectVariantGet(obj);
      setTimeout(() => { bundlePackHtml(); }, 100);
    }
  }

  // MINUS button - version one
  var minusBtn = e.target.closest('.bundle-builder-section.version-one .quantity-btn.minus');
  if (minusBtn) {
    var selector = minusBtn.parentElement;
    var input = selector.querySelector('.quantity-value');
    var current = parseInt(input.value) || 1;
    var variantId = parseInt(input.getAttribute('data-variant-id'));
    var bundleCart = document.querySelector('.right-product-details-side.bundle-cart');

    if (!variantId) return;

    if (current == 1) {
      selector.style.display = 'none';
      var productBtn = selector.parentElement.querySelector('.product-btn');
      if (productBtn) productBtn.style.display = '';

      bundleVariantData = bundleVariantData.filter((item) => item.variant_id != variantId);

      if (bundleCart) {
        bundleCart.querySelectorAll('.cart-product-item-wrapper .product-card').forEach((card) => {
          if (card.dataset.variantId == variantId) card.remove();
        });
        if (bundleCart.querySelectorAll('.cart-product-item-wrapper .product-card:not(.add-product-card)').length === 0) {
          var cartCount = bundleCart.querySelector('.cart-count');
          if (cartCount) cartCount.textContent = 0;
        }
      }

      if (minusBtn.classList.contains('bundle-picker')) {
        var collectionInput = document.querySelector('.bundle-builder-section .collection-item .quantity-selector .quantity-value[data-variant-id="' + variantId + '"]');
        if (collectionInput) {
          collectionInput.parentElement.style.display = 'none';
          var collectionBtn = collectionInput.parentElement.parentElement.querySelector('.product-btn');
          if (collectionBtn) collectionBtn.style.display = '';
        }
      }

      if (bundleVariantData.length == 0) {
        var tprice = Shopify.formatMoney(0);
        if (bundleCart) {
          var compareEl = bundleCart.querySelector('.bundle-cart-footer .original-price.compare-sub-total');
          var currentEl = bundleCart.querySelector('.bundle-cart-footer .current-price.sub-total');
          if (compareEl) compareEl.style.display = 'none';
          if (currentEl) currentEl.textContent = tprice;
        }
      }
    } else {
      var newVal = Math.max(current - 1, 1);
      input.value = newVal;
      input.dispatchEvent(new Event('change'));

      var variantIndex = bundleVariantData.findIndex((item) => item.variant_id == variantId);
      if (variantIndex > -1) bundleVariantData[variantIndex].variant_quantity = newVal;

      if (minusBtn.classList.contains('bundle-picker')) {
        var collectionInput = document.querySelector('.bundle-builder-section .collection-item .quantity-selector .quantity-value[data-variant-id="' + variantId + '"]');
        if (collectionInput) collectionInput.value = newVal;
      }
    }

    setTimeout(() => { bundlePackHtml(); }, 100);
  }
});
//PRODUCT COLLECTION QUANTITY PICKER JS END

//PACK BUILDER PROGRESSBAR JS START
function bundleBuilderProgress() {
  let strapCheck = 0;
  let productCount = 0;
  let items_subtotal = 0;
  var defaultProgress = 0;
  var bundleCart = document.querySelector('.right-product-details-side.bundle-cart');
  var v2Section = document.querySelector('.bundle-builder-section.version-two');
  console.log("bundleVariantData",bundleVariantData);
  if (bundleVariantData.length > 0) {
    const totals = calculateStrapTotals(bundleVariantData);
    var totalPrice = totals.totalPrice;
    var totalComparePrice = totals.totalComparePrice;

    for (var i = 0; i < bundleVariantData.length; i++) {
      if (bundleVariantData[i] != undefined) {
        var productTitle = bundleVariantData[i].product_title.toLowerCase();
        if (productTitle && productTitle.includes('strap') && !productTitle.includes('strap bag')) {
          strapCheck = 1;
          productCount += parseInt(bundleVariantData[i].variant_quantity);
          items_subtotal += parseInt(bundleVariantData[i].variant_original_price);
        }
      }

      var freeShippingProgressTarget = Number(window.abFreeShippingThreshold) || 80;
      var subtotal = totalPrice / 100;
      var conversionRate = (Shopify && Shopify.currency && Shopify.currency.rate) ? Shopify.currency.rate : 1;
      freeShippingProgressTarget = Math.round(freeShippingProgressTarget * conversionRate);
      console.log("freeShippingProgressTarget", freeShippingProgressTarget);
      var freeship = Math.round((subtotal * 100) / freeShippingProgressTarget);
      if (freeship > 100) freeship = 100;

      if (document.querySelector('.bundle-builder-section.version-one')) {
        var goal1 = 5;
        var goal3 = 7;
        productCount = parseInt(productCount);

        if (bundleCart) {
          bundleCart.querySelectorAll('.progress-stepper-container .step').forEach((s) => { s.classList.add('locked'); });
        }

        if (productCount > 0) {
          var discountFlashBuy = "1";
          var discountFlashFree = " 1 ";
          var discountMoreStrap = 1;
          var discountStraps = 1;

          if (productCount > 1) {
            var steps = bundleCart ? bundleCart.querySelectorAll('.progress-stepper-container .step') : [];
            if (steps.length > 0) steps[0].classList.remove('locked');

            if (productCount >= 2 && productCount < 5) {
              discountFlashBuy = "2"; discountFlashFree = " 3 ";
              var remaincount = goal1 - productCount;
              discountMoreStrap = remaincount; discountStraps = remaincount;
            } else if (productCount >= 5 && productCount < 7) {
              discountFlashBuy = "3"; discountFlashFree = " 4 ";
              var remaincount = goal3 - productCount;
              discountMoreStrap = remaincount; discountStraps = remaincount;
              if (steps.length > 1) { steps[0].classList.remove('locked'); steps[1].classList.remove('locked'); }
            } else if (productCount >= 7) {
              discountFlashBuy = ""; discountFlashFree = ""; discountMoreStrap = ''; discountStraps = '';
              if (steps.length > 2) { steps[0].classList.remove('locked'); steps[1].classList.remove('locked'); steps[2].classList.remove('locked'); }
            }
          }

          if (discountMoreStrap !== '') {
            var strapText = discountMoreStrap > 1 ? discountMoreStrap + ' more straps' : discountMoreStrap + ' more strap';
            var stepperContainer = bundleCart ? bundleCart.querySelector('.progress-stepper-container') : null;
            if (stepperContainer) {
              var countStrap = stepperContainer.querySelector('.count-strap');
              var strapFree = stepperContainer.querySelector('.strap-free');
              if (countStrap) countStrap.textContent = strapText;
              if (strapFree) strapFree.textContent = discountFlashFree;
            }
            var starpMsg = bundleCart ? bundleCart.querySelector('.progress-stepper-container .starp-text-message') : null;
            var starpCongrats = bundleCart ? bundleCart.querySelector('.progress-stepper-container .starp-text-message-congrats') : null;
            if (starpMsg) starpMsg.style.display = '';
            if (starpCongrats) starpCongrats.style.display = 'none';
            var charMsg = bundleCart ? bundleCart.querySelector('.progress-stepper-container .charcter-msg') : null;
            if (charMsg) charMsg.textContent = ' and';
          } else {
            var starpMsg = bundleCart ? bundleCart.querySelector('.progress-stepper-container .starp-text-message') : null;
            var starpCongrats = bundleCart ? bundleCart.querySelector('.progress-stepper-container .starp-text-message-congrats') : null;
            if (starpMsg) starpMsg.style.display = 'none';
            if (starpCongrats) starpCongrats.style.display = '';
            if (bundleCart) {
              bundleCart.querySelectorAll('.product-card.add-product-card').forEach((c) => { c.style.display = 'none'; });
            }
          }

          var freeShipRow = bundleCart ? bundleCart.querySelector('.bundle-cart-footer .free-shipping-row') : null;
          if (freeShipRow) freeShipRow.style.display = freeship >= 100 ? '' : 'none';

          if (productCount > 1) {
            var progressPercent = 0;
            var progressLineFill = bundleCart ? bundleCart.querySelector('.progress-line-fill') : null;
            if (progressLineFill) {
              if (productCount < goal1) {
                progressPercent = (productCount / goal3) * 100;
                if (progressPercent > 50) progressPercent = 48;
                if (productCount >= 2) progressPercent = progressPercent - 10;
              } else if (productCount === goal1) {
                progressPercent = (goal1 / goal3) * 100;
              } else if (productCount > goal1 && productCount < goal3) {
                progressPercent = (productCount / goal3) * 100 - 10;
              } else if (productCount >= goal3) {
                progressPercent = 100;
              }
              progressLineFill.style.width = Math.round(progressPercent) + '%';
            }
          } else {
            if (bundleCart) {
              bundleCart.querySelectorAll('.progress-stepper-container .step').forEach((s) => { s.classList.add('locked'); });
              var fill = bundleCart.querySelector('.progress-line-fill');
              if (fill) fill.style.width = '0%';
            }
          }
        }
      } else if (v2Section) {
        var freeShippingEl = v2Section.querySelector('.price-info .free-shipping');
        if (freeShippingEl) freeShippingEl.style.display = freeship >= 100 ? '' : 'none';
      }
    }
  } else {
    if (bundleCart) {
      bundleCart.querySelectorAll('.progress-stepper-container .step').forEach((s) => { s.classList.add('locked'); });
      var fill = bundleCart.querySelector('.progress-line-fill');
      if (fill) fill.style.width = '0%';
    }
    if (v2Section) {
      var compareEl = v2Section.querySelector('.price-column .original-price.compare-sub-total');
      var savingsEl = v2Section.querySelector('.price-column .savings');
      if (compareEl) compareEl.style.display = 'none';
      if (savingsEl) savingsEl.style.display = 'none';
    }
    if (bundleCart) {
      var charMsg = bundleCart.querySelector('.progress-stepper-container .charcter-msg');
      if (charMsg) charMsg.textContent = ',';
      var countStrap = bundleCart.querySelector('.progress-stepper-container .count-strap');
      if (countStrap) countStrap.textContent = '1 strap';
      bundleCart.querySelectorAll('.product-card.add-product-card').forEach((c) => { c.style.display = 'none'; });
    }
  }
}
//PACK BUILDER PROGRESSBAR JS END

//BUNDLE PACK SELECTED TO ADD TO CART JS START
document.addEventListener('click', (e) => {
  var checkoutBtn = e.target.closest('.bundle-builder-section .checkout-button');
  if (!checkoutBtn) return;
  bundlePackAddToCart();
});

function bundlePackAddToCart() {
  if (bundleVariantData.length > 0) {
    document.querySelectorAll('.bundle-builder-section .checkout-button').forEach((btn) => {
      btn.classList.add('btn--loading');
    });

    var itemArr = [];
    for (var i = 0; i < bundleVariantData.length; i++) {
      if (bundleVariantData[i] != undefined) {
        itemArr.push({
          id: parseInt(bundleVariantData[i].variant_id),
          quantity: parseInt(bundleVariantData[i].variant_quantity),
          properties: { '__single_bundle': 1 }
        });
      }
    }

    if (itemArr.length > 0) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemArr })
      })
        .then((res) => {
          if (!res.ok) throw new Error('Cart add failed');
          return res.json();
        })
        .then(() => {
          window.location.href = '/checkout';
        })
        .catch(() => {
          document.querySelectorAll('.bundle-builder-section .checkout-button').forEach((btn) => {
            btn.classList.remove('btn--loading');
          });
          console.log('fail');
        });
    }
  }
}

function sameBoxCard() {
  document.querySelectorAll('.bundle-builder-section .collection-wrapper').forEach((wrapper) => {
    var section = wrapper.closest('.bundle-builder-section');
    var widthVersion = 0;
    var winWidth = window.innerWidth;

    if (section.classList.contains('version-one')) {
      if (winWidth >= 1250) widthVersion = 3;
      else if (winWidth < 1250 && winWidth > 900) widthVersion = 2;
      else if (winWidth <= 900 && winWidth > 600) widthVersion = 3;
      else if (winWidth <= 600) widthVersion = 2;
    } else if (section.classList.contains('version-two')) {
      if (winWidth > 900) widthVersion = 4;
      else if (winWidth <= 900 && winWidth > 600) widthVersion = 2;
    }

    var cards = Array.from(wrapper.querySelectorAll('.product-info'));
    if (cards.length > 0) {
      cards.forEach((card) => {
        ['product-title', 'jdgm-preview-badge', 'color-variant', 'other-options'].forEach((cls) => {
          var el = card.querySelector('.' + cls);
          if (el) el.style.height = 'auto';
        });
      });

      for (var i = 0; i < cards.length; i += widthVersion) {
        var rowItems = cards.slice(i, i + widthVersion);

        function setMaxHeight(selector) {
          var maxHeight = 0;
          rowItems.forEach((card) => {
            var el = card.querySelector(selector);
            if (el) {
              var h = el.offsetHeight;
              if (h > maxHeight) maxHeight = h;
            }
          });

          if (selector === '.jdgm-preview-badge') {
            if (maxHeight > 0) {
              rowItems.forEach((card) => {
                var badge = card.querySelector('.jdgm-preview-badge');
                if (badge) {
                  badge.style.height = maxHeight + 'px';
                } else {
                  var titleEl = card.querySelector('.product-title');
                  if (titleEl) {
                    var placeholder = document.createElement('div');
                    placeholder.className = 'jdgm-preview-badge';
                    placeholder.style.cssText = 'visibility:hidden;height:' + maxHeight + 'px;';
                    titleEl.insertAdjacentElement('afterend', placeholder);
                  }
                }
              });
            }
          } else {
            if (maxHeight > 0) {
              rowItems.forEach((card) => {
                var el = card.querySelector(selector);
                if (el) el.style.height = maxHeight + 'px';
              });
            }
          }
        }

        setMaxHeight('.product-title');
        setMaxHeight('.jdgm-preview-badge');
        setMaxHeight('.color-variant');
        setMaxHeight('.other-options');
      }
    }
  });
}

window.addEventListener('resize', () => {
  sameBoxCard();
});

// VERSION V2 JS START
document.addEventListener('change', (e) => {
  var select = e.target.closest('.bundle-builder-section.version-two .product-variant-select');
  if (!select) return;
  var obj = select.parentElement.parentElement;
  var handleVariant = selectVariantGet(obj);
  if (handleVariant != undefined && handleVariant != '') {
    bundlePackHtml();
  }
});

document.addEventListener('click', (e) => {
  var closeIcon = e.target.closest('.bundle-builder-section.version-two .image-added .close-icon');
  if (!closeIcon) return;
  var imageBox = closeIcon.parentElement;
  var getVariantId = imageBox.getAttribute('data-variant-id');
  if (getVariantId != undefined && getVariantId != '') {
    imageBox.remove();
    var variantIndex = bundleVariantData.findIndex((item) => item.variant_id == getVariantId);
    if (variantIndex !== -1) bundleVariantData.splice(variantIndex, 1);
    bundlePackHtml();
  }
});

function v2blankBoxHtml() {
  var v2Section = document.querySelector('.bundle-builder-section.version-two');
  if (v2Section) {
    var stickyBuilder = v2Section.querySelector('.sticky-bundle-builder');
    if (stickyBuilder) {
      stickyBuilder.querySelectorAll('.image-box:not(.image-added)').forEach((box) => { box.remove(); });
    }
  }

  // Rendered by bundle-builder.liquid so the placeholder uses placeholder_svg_tag.
  var template = document.querySelector('[id^="BundleBlankSlot-"]');
  if (template) return template.innerHTML;

  // Older saved sections have no template — render the slot without an image.
  return '<div class="image-box blank-card"><div class="close-icon">' +
    '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="7" viewBox="0 0 8 7" fill="none">' +
    '<path d="M4.8687 3.32087L7.26209 5.71427L6.39339 6.58296L4 4.18957L1.60592 6.58365L0.737231 5.71496L3.13131 3.32087L0.73654 0.926103L1.60523 0.0574113L4 2.45218L6.39409 0.0581018L7.26278 0.926794L4.8687 3.32087Z" fill="white"/>' +
    '</svg></div>' +
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.75 7.25H16V8.75H8.75V16H7.25V8.75H0V7.25H7.25V0H8.75V7.25Z" fill="black"/></svg></div>';
}
// VERSION V2 JS END


/* =============================================
PRODUCT CARD SLIDER -- START
============================================= */
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".pro-collection-gallery").forEach(slider => {
        new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            pagination: {
            el: slider.querySelector(".swiper-pagination"),
            clickable: true
        },
        //   breakpoints: {
        //     640: {
        //       slidesPerView: 2
        //     },
        //     1024: {
        //       slidesPerView: 3
        //     }
        //   }
        });
    });
});
/* =============================================
PRODUCT CARD SLIDER -- END
============================================= */
